import BaseService from "service/base.js";

class EventService {
  load(type, first, last) {
    const parts = ["", "api", "events", type];
    if (first) {
      parts.push(first);
      parts.push(last);
    }

    return BaseService.get(parts.join("/"));
  }

  loadV3(start, end, filters) {
    const {
      targets,
      device: deviceId,
      name: eventName,
      priority: severity,
      source: sourceId,
    } = filters;

    return BaseService.get("/api/events/v3", {
      ...(targets ? { targets } : {}),
      start,
      end,
      deviceId,
      eventName,
      severity,
      sourceId,
    });
  }
}

const eventService = new EventService();

export default eventService;
export { eventService };
